import React from 'react';
import { X } from 'lucide-react';

const PressModal = ({ image, publication, onClose }) => {
  if (!image) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-[#F9F9F7]/95 backdrop-blur-sm"
      onClick={onClose}
      data-testid="press-modal"
    >
      <button
        onClick={onClose}
        className="absolute top-8 right-8 text-[#1A1A1A] hover:text-[#C6A87C] transition-colors"
        data-testid="close-modal-btn"
      >
        <X size={32} />
      </button>
      <div className="max-w-4xl max-h-[90vh] p-6" onClick={(e) => e.stopPropagation()}>
        <img 
          src={image} 
          alt={publication} 
          className="w-full h-auto object-contain shadow-2xl"
        />
      </div>
    </div>
  );
};

export default PressModal;